import React from "react"
import {Box, Typography} from "@mui/material"

import {HeaderContainer, HeaderWrapper, Title, GridWrapper, SecondaryContentContainer} from "../../../components"
import {AutocompleteContent, StyledContainer} from "../../component"

import Autocomplete from "../../../../../../components/Autocomplete"
import AutocompleteProducts from "../../../../../../components/AutocompleteProducts"
import {SuggestionItem} from "../../../../../../models/autocomplete"
import AutoCompleteContainer from "../../../components/AutocompleteContainer"
import GridContent from "../../../components/GridContent"
import {ContentContainerStyled, LoadingContainer} from "./components"

export type AutoCompleteProps = {
    isLoading: boolean
    isNoResults: boolean
    getAutoCompleteThunk: (suggestion: string) => void
    numFound: number
    suggestions: SuggestionItem[] | null
    text: any
    showSelectionHighlight: boolean
}

const Header = ({text}: any) => (
    <Box sx={{display: {xs: "block", md: "none"}}}>
        <HeaderContainer className="autocomplete-header" data-testid="autocomplete-header">
            <HeaderWrapper>
                <Title variant="h4">{text.headerText}</Title>
            </HeaderWrapper>
        </HeaderContainer>
    </Box>
)

export const Content = ({
    isLoading,
    getAutoCompleteThunk,
    text,
    isNoResults,
    showSelectionHighlight,
}: AutoCompleteProps) => {
    const handleFocus = (term: string, suggestion: string) => {
        if (term === suggestion) return
        getAutoCompleteThunk(suggestion)
    }
    return (
        <GridContent>
            <StyledContainer>
                <ContentContainerStyled
                    isNoResults
                    isRecentSearches={false}
                    showSelectionHighlight={showSelectionHighlight}
                    data-testid="header-auto-complete-content-container"
                >
                    <GridWrapper
                        isRecentSearches={false}
                        showSelectionHighlight={showSelectionHighlight}
                        data-testid="gridWrapper"
                    >
                        <AutocompleteContent>
                            <Autocomplete handleFocus={handleFocus} />
                        </AutocompleteContent>
                    </GridWrapper>
                </ContentContainerStyled>
                <SecondaryContentContainer>
                    {isLoading && (
                        <LoadingContainer>
                            <Typography variant="subtitle2">{text.loadingText}</Typography>
                        </LoadingContainer>
                    )}
                    {!isLoading && <AutocompleteProducts />}
                </SecondaryContentContainer>
            </StyledContainer>
        </GridContent>
    )
}

export const EnrichAutoComplete = (props: AutoCompleteProps) => {
    const showContent = props.numFound > 0 && props.suggestions && props.suggestions.length > 0
    return (
        <AutoCompleteContainer>
            {showContent ? (
                <>
                    <Header text={props.text} />
                    <Content {...props} />
                </>
            ) : (
                props.isNoResults && <Header text={props.text} />
            )}
        </AutoCompleteContainer>
    )
}

export default EnrichAutoComplete
